import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {RouteService} from "../../../services/route/route.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Route} from "../../../models/route";
import {combineLatest, forkJoin, merge} from "rxjs";
import {Media} from "../../../models/media";
import {MediaService} from "../../../services/media/media.service";
import {Artwork} from "../../../models/artwork";
import {environment} from '../../../../environments/environment';
import {DatabaseService} from "../../../services/database/database.service";
import {GroupService} from "../../../services/group/group.service";
import {MessagesService} from "../../../services/messages/messages.service";
import {ArtworkService} from "../../../services/artwork/artwork.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AuthService} from "../../../services/auth/auth.service";
import {RouteArtworkModal} from "../../../modals/route-artwork-modal/route-artwork-modal.component";

@Component({
    selector: 'app-edit-route',
    templateUrl: './edit-route.component.html',
    styleUrls: ['./edit-route.component.scss']
})
export class EditRouteComponent implements OnInit {

    code: string;
    route: Route;
    artworks: Array<Artwork> = [];
    assignedArtworks: Array<Artwork> = [];

    environment = environment;

    projectId: string;
    routeId: string;
    databaseId: string;

    routeForm: FormGroup;
    isAdmin: boolean;
    mediaImages: Array<Media>;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        private modalService: NgbModal,
        private groupService: GroupService,
        private mediaService: MediaService,
        private routeService: RouteService,
        private messagesService: MessagesService,
        private databaseService: DatabaseService,
        private artworkService: ArtworkService,
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.code = this.activatedRoute.snapshot.queryParams.c;
        this.isAdmin = this.authService.isAdmin();

        combineLatest(
            this.activatedRoute.parent.params,
            this.activatedRoute.params
        ).subscribe(
            params => {
                this.projectId = params[0]['project_id'];
                this.routeId = params[1]['route_id'];
                this.databaseId = params[0]['database_id'];

                this.routeForm = this.formBuilder.group({
                    name: ['', [Validators.required]],
                    color: ['', [Validators.required]],
                });

                forkJoin(
                    this.routeService.getSingleRoute(this.projectId, this.databaseId, this.routeId),
                    this.artworkService.getAllMyArtworks(this.projectId, this.databaseId),
                    this.mediaService.getAllMyMedia(this.projectId)
                ).subscribe(
                    () => {
                        this.route = this.routeService.route;
                        this.artworks = this.artworkService.artworks;
                        this.assignedArtworks = this.artworks.filter(artwork => this.route.artworks.includes(artwork._id));
                        this.mediaImages = this.mediaService.mediaImages;

                        // for (let i = 0; i < this.route.artworks.length; i++) {
                        //   this.route.artworks[i].images = this.route.artworks[i].images.map(i => {
                        //     const media = this.mediaImages.find(m => m._id === i['_id']);
                        //     return media || i;
                        //   });
                        //   this.route.artworks[i].audios = this.route.artworks[i].audios.map(i => {
                        //     const media = this.mediaAudios.find(m => m._id === i['_id']);
                        //     return media || i;
                        //   });
                        //   this.route.artworks[i].videos = this.route.artworks[i].videos.map(i => {
                        //     const media = this.mediaVideos.find(m => m._id === i['_id']);
                        //     return media || i;
                        //   });
                        // }
                    }, err => this.messagesService.errorToast(err),
                    () => this.routeForm.patchValue({...this.route.getObj(), database_id: this.databaseId})
                );
            },
            err => this.messagesService.errorModal(err.toString()),
        );


        this.routeService.onChange.subscribe(() => {
            this.route = this.routeService.route;
        });
        this.artworkService.onChange.subscribe(() => {
            this.artworks = this.artworkService.artworks;
            this.route.artworks = this.route.artworks.filter(artworkId => this.artworks.find(c => c._id === artworkId));
        });
    }

    onSubmit() {
        const payload = new Route(this.routeForm.getRawValue());

        this.routeService.patchRoute(this.projectId, this.databaseId, this.routeId, payload)
            .subscribe(
            () => {
                this.messagesService.successToast('Route updated!', 'Done!');
                this.router.navigate(['/projects/' + this.projectId + '/databases/' + this.databaseId])
                    .catch(err => this.messagesService.errorToast(err));
            },
            err => this.messagesService.errorToast(err)
        );
    }

    onRemoveArtwork(artworkId: string) {
        this.messagesService.confirmModal().result
            .then(
                result => {
                    if (result) {
                        this.routeService.removeArtwork(this.projectId, this.databaseId, this.routeId, artworkId).subscribe(
                            () => {
                                this.assignedArtworks = this.artworks.filter(artwork => this.route.artworks.includes(artwork._id));
                                this.messagesService.successToast('Artwork removed from Route.');
                            },
                            err => this.messagesService.errorToast(err)
                        );
                    }
                })
            .catch(() => {
            });
    }

    findArtworkById(id: string) {
        return this.artworks.find(c => c._id === id);
    }

    onShowModal() {
        this.routeArtworkModal(this.artworks.filter(({_id}) => this.assignedArtworks.findIndex((art => art._id === _id)) === -1));
    }

    routeArtworkModal(artworks: Array<Artwork>) {
        const modalRef = this.modalService.open(RouteArtworkModal, {size: 'lg'});
        modalRef.componentInstance.databaseId = this.databaseId;
        modalRef.componentInstance.projectId = this.projectId;
        modalRef.componentInstance.routeId = this.routeId;
        modalRef.componentInstance.code = this.code;
        modalRef.componentInstance.artworks = artworks;
        modalRef.componentInstance.media = this.mediaService.mediaImages;

        modalRef.componentInstance.addArtworkEmitter.subscribe((artworkIds: string[]) => {
            this.routeService.addArtwork(this.projectId, this.databaseId, this.routeId, artworkIds)
                .subscribe(
                    () => {
                        this.assignedArtworks = this.artworks.filter(artwork => this.route.artworks.includes(artwork._id));
                        this.messagesService.successToast('Artworks added.');
                    },
                    err => this.messagesService.errorToast(err),
                    () => modalRef.close(true)
                );
        });
    }

    getImage(artwork: Artwork): string {
        const media = this.mediaService.mediaImages.find(({_id}) => _id === artwork.image_cover);
        return media ? `${environment.museonPieServer}/media/${media.uri}?museum_id=${this.code}` : '';
    }

    onSelectImageCover(media: Media) {
        this.routeForm.patchValue({
            cover: media._id
        });
    }

    onRemoveImageCover(media: Media) {
        this.routeForm.patchValue({
            cover: null
        });
    }
}
